// src/components/SystemAdmin/DefineTaxonomyModal.js
import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { createGlobalTaxonomy } from '../../api/api';

const DefineTaxonomyModal = ({ show, onHide, onCreated }) => {
  const [form, setForm] = useState({
    name: '',
    description: '',
    levels: 'Module, Unit, Topic',
    verbs: '{\n  "Remember": ["define", "list", "recall"],\n  "Understand": ["explain", "describe"]\n}'
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setSaving(true);
    setError('');
    try {
      const payload = {
        name: form.name,
        description: form.description,
        levels_config: { structure: form.levels.split(',').map(s => s.trim()) },
        verbs_config: JSON.parse(form.verbs), // Validates JSON format
        reference_policy: { "allow_external": true }
      };

      await createGlobalTaxonomy(payload);
      onCreated();
      onHide();
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid JSON format in Verbs Configuration");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton><Modal.Title>Define New Taxonomy Standard</Modal.Title></Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger" role="alert">{error}</Alert>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Standard Name (e.g. Bloom's Revised)</Form.Label>
            <Form.Control 
              value={form.name} 
              onChange={e => setForm({...form, name: e.target.value})} 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Hierarchy Levels (Comma separated)</Form.Label>
            <Form.Control 
              value={form.levels} 
              onChange={e => setForm({...form, levels: e.target.value})}
              placeholder="Module, Unit, Topic"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Verbs Configuration (JSON Object)</Form.Label>
            <Form.Control 
              as="textarea" rows={6} 
              style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}
              value={form.verbs} 
              onChange={e => setForm({...form, verbs: e.target.value})}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={saving}>
          {saving ? 'Saving...' : 'Create Standard'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DefineTaxonomyModal;
